import React from 'react';
import { P1, P2 } from 'styleguide/Texts';
import { View } from 'styleguide/View';
import { Spacing } from 'styleguide/spacing';
import DownloadAppstore from 'assets/download-appstore.svg';
import DownloadGooglePlay from 'assets/download-googleplay.svg';
import { Card } from 'styleguide/Card';
import { SecondaryButton } from 'styleguide/Buttons';
import { t } from 'translations/t';

interface FolderDetailHevyCTACardProps {
  onCopyUrl: () => void;
}

export const FolderDetailHevyCTACard = (props: FolderDetailHevyCTACardProps) => {
  return (
    <Card style={{ padding: Spacing.lg }}>
      <View style={{ alignItems: 'center' }}>
        <P1 style={{ paddingBottom: Spacing.sm }}>{t('web.folderDetail.saveFolder')}</P1>
        <P2 style={{ paddingBottom: Spacing.md, textAlign: 'center' }} type="secondary">
          {t('web.folderDetail.saveFolder.desc')}
        </P2>
        <View
          style={{
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginBottom: Spacing.md,
          }}
        >
          <a href="https://hevyapp.app.link/8V2C2zMIBNb">
            <DownloadAppstore />
          </a>
          <a href="https://hevyapp.app.link/MrrZGFPIBNb">
            <DownloadGooglePlay />
          </a>
        </View>
      </View>
      <SecondaryButton
        title={t('web.folderDetail.copyLinkToFolder')}
        onClick={props.onCopyUrl}
        iconType={'link'}
      />
    </Card>
  );
};
